export default __webpack_public_path__ + "static/media/icon_other_gems.8592e86f.png";